<template>
  <v-card 
    v-if="!reportData.hidden || isAdmin" 
    :class="{
      'strategio-hidden-item': reportData.hidden //,
      // 'elevation-9': reportData.isMoving
    }"
    :style="[
      {'height': '275px'},
      {'width': '250px'},
      {'display': 'inline-block'},
      {'margin': '8px'},
      {'vertical-align': 'top'},
      {'overflow': 'hidden'},
      {'border-radius': '20px 16px'}
    ]"

  >
    <v-card-title class="py-0 pt-1" style="height:52px;background-color:#FAB100">
      <v-layout row align-center>
        <v-flex xs10 style="font-size:14px;font-weight:bold;line-height:normal;color:white;cursor:pointer;"
          @click="showReport(reportData)"
        >
          {{reportData.itemName}}
        </v-flex>
        <v-flex xs2>
          <item-menu :contained-by="containedBy" :item="reportData" v-if="isAdmin || reportData.url2.trim() !== ''" :is-searching="isSearching"></item-menu>          
        </v-flex>
      </v-layout>
    </v-card-title>
    <!-- <v-card-actions class="white"> -->
      <!-- <v-btn flat icon
        :disabled="!!reportData.heritable"
        :color="reportData.isFavorite ? 'amber darken-1' : 'grey darken-1'"
        @click="setFavorite(reportData)"
        id="addfavortite-button"
      >
        <v-icon>star</v-icon>
      </v-btn> -->
      <!-- <div class="strategio-card-title" @click="showReport(reportData)">
        {{reportData.itemName}}
      </div> -->
      <!-- <v-spacer></v-spacer> -->
      <!-- <item-menu :contained-by="containedBy" :item="reportData" v-if="isAdmin" :is-searching="isSearching"></item-menu> -->
    <!-- </v-card-actions> -->
      <!-- :src="reportData.imageUrl ? reportData.imageUrl : (reportData.heritable ? placeholderImage : require('@/assets/logo.png'))" -->
    <v-card-text class="pa-0" style="height:151px">
      <v-layout fill-height row>
        <v-flex xs8 offset-xs2 class="">
          <v-layout align-center fill-height class="pt-3 pb-2 pa-1">
            <!-- :src="reportData.imageUrl ? reportData.imageUrl : (reportData.heritable ? getImageUrl(placeholderImage) : getImageUrl(previewImage))" alt="" -->
            <!-- :src="require('@/assets/placeholder.png')" -->
            <v-flex
              class="fill-height"
              style="border:1px red none; width:100%;border:1px red none;cursor:pointer;"
              @click="showReport(reportData)"
            >
              <img
                height="100%"
                style="max-width:100%;display:block;margin:0px auto;"
                :src="getImageUrl(reportData)" alt="report-img"
              >
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex xs2>
          <v-layout justify-center>
            <v-btn flat icon small class="ma-0 mt-1"
              :color="reportData.isFavorite ? 'amber darken-1' : 'grey darken-1'"
              @click="setFavorite(reportData)"
            >
              <v-icon>star</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <!-- <v-card-media
      :src="reportData.imageUrl ? reportData.imageUrl : (reportData.heritable ? getImageUrl(placeholderImage) : getImageUrl(previewImage))"
      contain
      height="100px"
      @click="showReport(reportData)"
      style="cursor: pointer"
    > -->
    <!-- </v-card-media> -->
    <v-card-text class="pa-0 px-2" style="height:31px;">
      <!-- <div> -->
      <span style="font-size:11px;line-height:1.3;display:block;">
        {{reportData.description.replace('$$FOLDER', this.containedBy.itemName)}}
      </span>
      <!-- </div> -->
    </v-card-text>
    <!-- <div class="pa-1" style="white-space:nowrap;overflow-x:scroll;"> -->
    <div class="pa-1" style="height:38px;white-space:normal;overflow-y:auto;">
      <v-chip small
        v-for="c in getChipsData(reportData.labels)" :key="c"
        class="strategio-chip-component"
        style="color:white;background-color:#19BAE8;font-size:12px;"
        @click="searchByChip(c)"
      >{{c}}</v-chip>
    </div>
  </v-card>
</template>

<script>
import ItemMenu from '../menus/item-menu.vue'
import reportsStorage from '../../storage/reportsStorage'
import userStorage from '../../storage/userStorage'
import eventBus from '../../utils/eventBus'

export default {
  name: 'report-list-item',
  data () {
    const user = userStorage.getUserInfo()
    const previewImage = reportsStorage.getDefaultPreviewImage()
    const placeholderImage = reportsStorage.getDefaultPlaceholderImage()
    return {
      previewImage: previewImage,
      placeholderImage: placeholderImage,
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN'
    }
  },
  methods: {
    searchByChip (c) {
      this.searchProps.searchCriteria = c
      this.searchItems()
    },
    getImageUrl (report) {
      let reportImage = ''
      const reportImagesFolderPath = 'assets/report-imgs'
      const images = {
        isExcel: `${reportImagesFolderPath}/icon-excel.png`,
        isPowerBI: `${reportImagesFolderPath}/icon-powerbi.png`,
        custom1: `${reportImagesFolderPath}/icon-alt1.png`,
        custom2: `${reportImagesFolderPath}/icon-alt2.png`
      }
      if (!report.imageUrl) { // Siempre y cuando no lleven imageUrl
        if (report.isPowerBI) {
          reportImage = images.isPowerBI
        } else {
          reportImage = images.isExcel
        }
        reportImage = require('@/' + reportImage)
      } else {
        reportImage = report.imageUrl
      }

      return reportImage
    },
    setFavorite (report) {
      console.log('en prueba')
      if (this.favoritesPage) {
        if (report.isFavorite === 0 || report.isFavorite === false) {
          return
        }
      } else {
        if (report.isFavorite === 1 || report.isFavorite === true) {
          return
        }
      }

      if (this.userType !== 'DEMO') {
        report.isFavorite = !report.isFavorite
        this.isFavorite = report.isFavorite
        reportsStorage.setFavorite(report.itemID, report.isFavorite, {})
      }
    },
    getChipsData (text) {
      if (text) {
        text = text.replace('$$FOLDER', this.containedBy.itemName)
        return text.split(',').map((item, index) => item.trim())
      }
      return []
    },
    showReport (data) {
      if (data.url1.trim() === '') {
        // descargar si hay url2
        if (data.url2.trim() === '') {
          // descargar reporte y notificar
          eventBus.$emit('open-custom-snack-bar', {message: 'No hay URL de visualización ni de descarga', itsOk: 'warning'})
        } else {
          // Notificar que no hay url de visualizacion ni descarga
          window.open(data.url2, '_blank')
          reportsStorage.registerView(data.itemID, 'DOWNLOAD')
          eventBus.$emit('open-custom-snack-bar', {message: 'No hay URL de visualización. Descargando reporte', itsOk: 'warning'})
        }
      } else {
        let _isFavorite = ''
        if (this.$route.name === 'Favorites') {
          _isFavorite = '/1'
        }
        this.$router.push(`/show-report/${data.itemID}${_isFavorite}`)
      }
    }
  },
  props: {
    reportData: {
      type: Object,
      default () {
        return {}
      }
    },
    favoritesPage: {
      type: Boolean,
      default () {
        return false
      }
    },
    isSearching: {
      type: Boolean,
      default () {
        return false
      }
    },
    containedBy: {
      type: Object,
      default () {
        return {}
      }
    },
    searchProps: {
      type: Object,
      default () {
        return { searchCriteria: '' }
      }
    },
    searchItems: {
      type: Function,
      default () {
        return () => { alert('Err func') }
      }
    }
  },
  components: {
    ItemMenu
  }
}
</script>
<style>
.strategio-card-title {
  padding: 8px 4px;
  font-size: 14px;
  font-weight: 300;
  cursor: pointer;
  color: #1976D2;
}
.strategio-hidden-item {
  opacity: 0.5;
}

span.strategio-chip-component>span.chip__content {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/report-list-item.vue